import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, Fragment } from 'react';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { deepExtract } from 'helpers/deep';
import { SearchVenue } from 'features/Search/models/SearchVenue';
import { PanelSection } from './PanelSection';
import { SearchBoxNoResults } from './Items/SearchBoxNoResults';
import { Favorites } from './Items/Favorites';
import { Activity } from './Items/Activity';
import { Link } from './Items/Link';
import { Venue } from './Items/Venue';
import { Loader } from './Loader';
import { ITEM_TYPES } from './SearchBox.constants';
var messages = defineMessages({
  noMatches: {
    id: 'searchbox.item.noMatches',
    defaultMessage: 'No matches'
  }
});
export var KeywordSearchBoxPanel =
/*#__PURE__*/
function (_Component) {
  _inherits(KeywordSearchBoxPanel, _Component);

  function KeywordSearchBoxPanel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, KeywordSearchBoxPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(KeywordSearchBoxPanel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "renderLink", function (link, highlighted, itemProps) {
      return React.createElement(Link, _extends({
        to: link.to,
        label: link.label,
        key: "links",
        highlighted: highlighted
      }, itemProps));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFavorite", function (_, highlighted, itemProps) {
      return React.createElement(Favorites, _extends({
        key: "faves",
        highlighted: highlighted
      }, itemProps));
    });

    _defineProperty(_assertThisInitialized(_this), "renderVenue", function (venue, highlighted, itemProps) {
      return React.createElement(Venue, _extends({
        key: venue.id,
        highlighted: highlighted,
        onRemoveClick: _this.props.onRemoveItem
      }, venue, itemProps));
    });

    _defineProperty(_assertThisInitialized(_this), "renderActivity", function (activity, highlighted, itemProps) {
      return React.createElement(Activity, _extends({
        searchId: activity.search_id,
        key: activity.id,
        nameHighlighted: activity.name_highlighted || activity.name,
        vertical: activity.vertical,
        highlighted: highlighted,
        onRemoveClick: _this.props.onRemoveItem
      }, itemProps));
    });

    return _this;
  }

  _createClass(KeywordSearchBoxPanel, [{
    key: "getRenderMethodForItem",
    value: function getRenderMethodForItem(_ref) {
      var _ITEM_TYPES$venue$ITE;

      var type = _ref.type;
      return (_ITEM_TYPES$venue$ITE = {}, _defineProperty(_ITEM_TYPES$venue$ITE, ITEM_TYPES.venue, this.renderVenue), _defineProperty(_ITEM_TYPES$venue$ITE, ITEM_TYPES.activity, this.renderActivity), _defineProperty(_ITEM_TYPES$venue$ITE, ITEM_TYPES.favorites, this.renderFavorite), _defineProperty(_ITEM_TYPES$venue$ITE, ITEM_TYPES.links, this.renderLink), _ITEM_TYPES$venue$ITE)[type];
    }
  }, {
    key: "getSections",
    value: function getSections() {
      var _this$props = this.props,
          hasQuery = _this$props.hasQuery,
          venues = _this$props.venues,
          activities = _this$props.activities,
          history = _this$props.history,
          isLoggedIn = _this$props.isLoggedIn,
          favoritesEnabled = _this$props.favoritesEnabled;
      var sections = [];
      var path = deepExtract('pathname', browserHistory.getCurrentLocation(), '');

      if (!path.startsWith('/search')) {
        sections.push({
          key: 'links',
          items: [{
            to: '/search',
            type: 'links',
            name: 'Show all classes',
            label: React.createElement(FormattedMessage, {
              id: "search.panel.show-all-classes",
              defaultMessage: "Show all classes"
            })
          }]
        });
      }

      if (!hasQuery && history.length) {
        sections.push({
          key: 'history',
          items: history
        });
      }

      if (activities.length) {
        sections.push({
          key: 'activities',
          title: hasQuery ? React.createElement(FormattedMessage, {
            id: "search.panel.matched-activities",
            defaultMessage: "Activities"
          }) : React.createElement(FormattedMessage, {
            id: "search.panel.popular-activities",
            defaultMessage: "Popular activities"
          }),
          items: activities
        });
      }

      if (favoritesEnabled && isLoggedIn) {
        sections.push({
          key: 'favorites',
          items: [{
            id: 'favorites',
            type: ITEM_TYPES.favorites,
            name: 'Your favorites'
          }]
        });
      }

      if (venues.length) {
        sections.push({
          key: 'venues',
          title: hasQuery ? React.createElement(FormattedMessage, {
            id: "search.panel.matched-venues",
            defaultMessage: "Venues"
          }) : React.createElement(FormattedMessage, {
            id: "search.panel.popular-venues",
            defaultMessage: "Popular venues"
          }),
          items: venues
        });
      }

      return sections;
    }
  }, {
    key: "renderResults",
    value: function renderResults() {
      var _this2 = this;

      var _this$props2 = this.props,
          getItemProps = _this$props2.getItemProps,
          highlightedIndex = _this$props2.highlightedIndex;
      var sections = this.getSections();
      var indexStart = 0;
      return React.createElement(Fragment, null, sections.map(function (_ref2) {
        var key = _ref2.key,
            title = _ref2.title,
            items = _ref2.items;
        var indexBase = indexStart;
        indexStart += items.length;
        return React.createElement(PanelSection, {
          key: key,
          title: title
        }, items.map(function (item, i) {
          return _this2.getRenderMethodForItem(item)(item, indexBase + i === highlightedIndex, getItemProps({
            item: item
          }));
        }));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          hasResults = _this$props3.hasResults,
          intl = _this$props3.intl,
          isLoading = _this$props3.isLoading,
          onPanelScroll = _this$props3.onPanelScroll;
      var sectionItems;

      if (isLoading) {
        sectionItems = React.createElement(Loader, null);
      } else if (hasResults) {
        sectionItems = this.renderResults();
      } else {
        sectionItems = React.createElement(SearchBoxNoResults, {
          message: intl.formatMessage(messages.noMatches)
        });
      }

      return React.createElement("div", {
        className: "dropdown searchbox__panel",
        onScroll: onPanelScroll
      }, React.createElement("div", {
        className: "dropdown__content"
      }, sectionItems));
    }
  }]);

  return KeywordSearchBoxPanel;
}(Component);
KeywordSearchBoxPanel.propTypes = {
  onRemoveItem: PropTypes.func.isRequired,
  getItemProps: PropTypes.func.isRequired,
  highlightedIndex: PropTypes.number,
  intl: intlShape.isRequired,
  isLoading: PropTypes.bool,
  isLoggedIn: PropTypes.bool.isRequired,
  favoritesEnabled: PropTypes.bool,
  hasQuery: PropTypes.bool.isRequired,
  hasResults: PropTypes.bool.isRequired,
  venues: PropTypes.arrayOf(PropTypes.instanceOf(SearchVenue)),
  activities: PropTypes.array.isRequired,
  history: PropTypes.array.isRequired,
  onPanelScroll: PropTypes.func
};